import SimpleDrawer from '../../shared/simple-drawer-new';
import { ActivityModel } from '../../../types';
import { eventNames } from '../../shared/event-names';
import { useMemo } from 'react';
import SharedReviewLayoutMainCard, {
  MainSectionItem,
} from '../../shared/shared-review-layout-main-card';
import SharedReviewLayoutNew, {
  ReviewSection,
} from '../../shared/shared-review-layout-new';
import Check from '@mui/icons-material/Check';

interface LogDetailsDrawerProps {
  open: boolean;
  handleClose: () => void;
  selectedLog: ActivityModel | null;
}

export default function LogDetailsDrawer({
  open,
  handleClose,
  selectedLog,
}: Readonly<LogDetailsDrawerProps>) {
  const name = selectedLog?.events[0]?.name || '';
  const parameters = selectedLog?.events[0]?.parameters || [];
  const event = eventNames.find((event) => event.value === name);

  function getEventDescription(
    event:
      | {
          value: string;
          label: string;
          messageFormat: (props: never) => string;
        }
      | undefined
  ) {
    if (!event) {
      return 'N/A';
    } else if (event.messageFormat) {
      const formattedParameters = parameters.map((param) => {
        return {
          [param.name]: param.value,
        };
      });
      const parametersObject = Object.assign({}, ...formattedParameters);
      return event.messageFormat(parametersObject as never);
    } else {
      return 'N/A';
    }
  }

  const sections: ReviewSection[] = useMemo(() => {
    if (!selectedLog) return [];
    return [
      {
        title: 'Basic Information',
        leftItems: [
          {
            label: 'Actor',
            value: selectedLog.actor.email
              ? [
                  {
                    email: selectedLog.actor.email,
                    type: 'User' as const,
                  },
                ]
              : 'N/A',
            variant: 'chip',
          },
          {
            label: 'Event Type',
            value: selectedLog.events[0]?.type || 'N/A',
          },
          {
            label: 'IP Address',
            value: selectedLog.ipAddress || 'N/A',
          },
        ],
      },
    ];
  }, [selectedLog]);

  const mainSection: MainSectionItem = {
    mainTitle: event ? event.label : name,
    description: getEventDescription(event),
    fields: [
      {
        label: 'Created',
        value: selectedLog
          ? new Date(selectedLog.id.time.value).toLocaleString() || 'N/A'
          : 'N/A',
        icon: Check,
      },
    ],
  };

  return (
    <SimpleDrawer open={open} title="cPanel Log Details" onClose={handleClose}>
      {selectedLog && (
        <>
          <SharedReviewLayoutMainCard section={mainSection} isDrawer />

          <SharedReviewLayoutNew leftSections={sections} isDrawer />
        </>
      )}
    </SimpleDrawer>
  );
}
